export const NAVIGATION_MENU_SKELETON_SELECTOR = '.cmp-navigation-menu-skeleton';

export const hideNavigationMenuSkeleton = (): void => {
  document.querySelector(NAVIGATION_MENU_SKELETON_SELECTOR)?.classList.add('hide');
};
